export default __webpack_public_path__ + "static/main-img02-12cb917883ea5783008c10d345469944.jpg";